import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import React, { useMemo } from 'react'
import { promoCodesWhereTheyWorkHelpUrl } from 'utilities/urlUtils'
import { orderingCompatibility, posCompatibility } from '../compatibility'
import { MobileOrderingIcon, StorefrontIcon } from '../icons'
import CompatibilityCard from './CompatibilityCard'

const t = buildTranslate('promo_codes.overview.where_it_works')

type Props = {
  onActivateOlo: () => void
}

const WherePromoCodesWork = ({ onActivateOlo }: Props) => {
  const [css] = useStyletron()
  const merchant = useCurrentMerchant()
  const toastInstoreEnabled = useFlag('toast-promo-instore-beta', false)

  const orderingRows = useMemo(
    () => orderingCompatibility(merchant),
    [merchant]
  )
  const posRows = useMemo(
    () => posCompatibility(merchant, toastInstoreEnabled),
    [merchant, toastInstoreEnabled]
  )

  return (
    <section data-testid="promo-codes-where-it-works">
      <Text.Header3 tag="h2" color="grey90" className="mt-0 mb-m">
        {t('title')}
      </Text.Header3>
      <div
        className={css({
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          // Ordering and POS rarely have the same row count; stretching would
          // leave a tall blank inside whichever card is shorter.
          alignItems: 'start',
          gap: '24px',
        })}
      >
        <CompatibilityCard
          title={t('online.title')}
          description={t('online.description')}
          emptyText={t('online.empty')}
          Icon={MobileOrderingIcon}
          rows={orderingRows}
          onActivate={onActivateOlo}
        />
        <CompatibilityCard
          title={t('instore.title')}
          description={t('instore.description')}
          emptyText={t('instore.empty')}
          Icon={StorefrontIcon}
          rows={posRows}
        />
      </div>
      <Text.BodyText4 color="grey70" tag="p" className="mt-m mb-0">
        {t('footnote')}{' '}
        <a
          href={promoCodesWhereTheyWorkHelpUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footnote_link')}
        </a>
      </Text.BodyText4>
    </section>
  )
}

export default WherePromoCodesWork
